module.exports = __webpack_public_path__ + "2c0876a7081531890e05e3ae762264e4.pdf";